import { pageDefinitions } from '~/constants/pages'

export const useGridCard = (data) => {
  if (!pageDefinitions[data.collection]?.card) {
    console.warn(`Missing card for ${data.collection}`)
    return {
      size: 'small',
      component: 'div',
      data
    }
  }

  return { ...pageDefinitions[data.collection].card, data }
}
